// /* global Office, Word, document, console */
// /* eslint-disable no-restricted-globals */

// // ──────────────────────────────────────────────────────
// // PERFORMANCE TRACKING UTILITIES (UNCHANGED)
// // ──────────────────────────────────────────────────────
// const PerfTracker = {
//   timers: {},
//   start(label) {
//     this.timers[label] = performance.now();
//     console.log(`⏱️ [START] ${label}`);
//   },
//   end(label) {
//     if (!this.timers[label]) return;
//     const duration = performance.now() - this.timers[label];
//     console.log(`✅ [END] ${label}: ${duration.toFixed(2)}ms`);
//     delete this.timers[label];
//     return duration;
//   }
// };

// // ──────────────────────────────────────────────────────
// // IMPORTS
// // ──────────────────────────────────────────────────────
// import { AudioRecorder } from "../lib/AudioRecorder.js";
// import { EnhancedWebSocketManager } from "../lib/EnhancedWebSocketManager.js";
// import { showNotification } from "../lib/UiNotification.js";
// import { goToNextField, goToPreviousField } from "./documentNavigator.js";
// import { TextExtractor } from "../lib/TextExtractor.js";
// import 'core-js/modules/es.string.includes';
// import 'core-js/modules/es.string.starts-with';
// import {
//   FieldStateManager,
//   performSurgicalFieldUpdate
// } from "../lib/surgical_update_system.js";

// // ──────────────────────────────────────────────────────
// // GLOBAL STATE
// // ──────────────────────────────────────────────────────
// window.isRecording = false;
// window.audioRecorder = null;
// window.wsManager = null;
// window.currentRecordingId = null;

// let isBackendConnected = false;

// // ──────────────────────────────────────────────────────
// // TRANSCRIPTION BUFFER (UNCHANGED)
// // ──────────────────────────────────────────────────────
// const FLUSH_DELAY_MS = 50;
// const MIN_CHARS_TO_FLUSH = 1;

// let pendingInsertQueue = [];
// let flushTimeout = null;
// let isFirstTranscription = true;

// // Cursor monitoring for "Conclusion" detection
// let cursorMonitor = null;


// // ──────────────────────────────────────────────────────
// // CONFIG
// // ──────────────────────────────────────────────────────
// const BACKEND_URL = "ws://localhost:8765/word_addin";
// const DOCTOR_USERNAME = "default_user";
// const DOCTOR_DEPARTMENT = "radiology"; // Add your department
// const CONCLUSION_MARKER = "Եզրակացություն"; // Configurable marker word
// const DATE_MARKER = "Ամսաթիվ"; // Date marker


// // ──────────────────────────────────────────────────────
// // DATE HELPER FUNCTION
// // ──────────────────────────────────────────────────────
// function getTodayDateArmenian() {
//   const today = new Date();
//   const day = String(today.getDate()).padStart(2, '0');
//   const month = String(today.getMonth() + 1).padStart(2, '0');
//   const year = today.getFullYear();
//   return `${day}.${month}.${year}թ.`;
// }


// // ──────────────────────────────────────────────────────
// // AUTO-DATE INSERTION FEATURE
// // ──────────────────────────────────────────────────────
// async function updateDateAutomatically() {
//   try {
//     await Word.run(async (context) => {
//       // Search for "Ամսաթիվ" in the document
//       const searchResults = context.document.body.search(DATE_MARKER, {
//         matchCase: true,
//         matchWholeWord: false
//       });

//       searchResults.load("items");
//       await context.sync();

//       if (searchResults.items.length === 0) {
//         console.log("❌ Date marker 'Ամսաթիվ' not found in document");
//         return;
//       }

//       // Get the first occurrence
//       const firstMatch = searchResults.items[0];
//       firstMatch.load("text");
//       await context.sync();

//       // Get the entire line/paragraph containing "Ամսաթիվ"
//       const paragraph = firstMatch.paragraphs.getFirst();
//       paragraph.load("text");
//       await context.sync();

//       // Get the range after "Ամսաթիվ" to the end of paragraph
//       const afterRange = firstMatch.getRange(Word.RangeLocation.after);
//       const endOfParagraph = paragraph.getRange(Word.RangeLocation.end);

//       // Expand range from after "Ամսաթիվ" to end of paragraph
//       const contentAfterMarker = afterRange.expandTo(endOfParagraph);
//       contentAfterMarker.load("text");
//       await context.sync();

//       // Format: "Ամսաթիվ ____  24.01.2025թ. __"
//       const dateText = ` ____  ${getTodayDateArmenian()} __`;

//       // Replace whatever is after "Ամսաթիվ" with new date
//       const insertedRange = contentAfterMarker.insertText(dateText, Word.InsertLocation.replace);
//       await context.sync();

//       // Highlight the inserted text directly
//       insertedRange.font.highlightColor = "Grey"; // highlight
//       await context.sync();

//       console.log(`✅ Date updated and highlighted: ${dateText}`);

//       // Remove highlight after 2.5 seconds
//       setTimeout(async () => {
//         try {
//           await Word.run(async (ctx) => {
//             // Search for the date marker again
//             const searchAgain = ctx.document.body.search(DATE_MARKER, {
//               matchCase: true,
//               matchWholeWord: false
//             });
//             searchAgain.load("items");
//             await ctx.sync();

//             if (searchAgain.items.length > 0) {
//               const match = searchAgain.items[0];
//               const para = match.paragraphs.getFirst();
//               para.load("text");
//               await ctx.sync();

//               // Get range after marker and highlight it
//               const afterRng = match.getRange(Word.RangeLocation.after);
//               const endOfPara = para.getRange(Word.RangeLocation.end);
//               const highlightRange = afterRng.expandTo(endOfPara);
//               highlightRange.font.highlightColor = null; // Remove highlight
//               await ctx.sync();
//             }
//           });
//         } catch (err) {
//           console.warn("Could not remove highlight:", err);
//         }
//       }, 2500);

//     });
//   } catch (error) {
//     console.error("❌ Error updating date:", error);
//   }
// }


// // ──────────────────────────────────────────────────────
// // FINISH REPORT - REMOVE ALL BRACKETS
// // ──────────────────────────────────────────────────────
// async function finishReport() {
//   try {
//     await Word.run(async (context) => {
//       // Search for all bracket fields using the same pattern as navigation
//       const results = context.document.body.search("\\[*\\]", {
//         matchWildcards: true
//       });

//       results.load("items");
//       await context.sync();

//       if (results.items.length === 0) {
//         console.log("✅ No brackets found in document");
//         updateStatus("No brackets to remove");
//         try {
//           showNotification("Document already finalized - no brackets found", "info");
//         } catch (e) {
//           console.warn("Failed to show notification:", e);
//         }
//         return;
//       }

//       const totalBrackets = results.items.length;
//       console.log(`🗑️ Removing ${totalBrackets} bracket fields...`);

//       // Remove brackets from each field, keeping the inner content
//       for (const field of results.items) {
//         field.load("text");
//         await context.sync();

//         const fieldText = field.text;
//         // Extract content between '[' and ']'
//         const innerText = fieldText.slice(1, -1);

//         // Replace the entire field (including brackets) with just the inner text
//         field.insertText(innerText, Word.InsertLocation.replace);
//       }

//       await context.sync();

//       console.log(`✅ Successfully removed ${totalBrackets} bracket fields`);
//       updateStatus("Report finalized");

//       try {
//         showNotification(`Report finalized! Removed ${totalBrackets} bracket fields.`, "success");
//       } catch (e) {
//         console.warn("Failed to show notification:", e);
//       }
//     });
//   } catch (error) {
//     console.error("❌ Error removing brackets:", error);
//     updateStatus("Error finalizing report");
//     try {
//       showNotification("Failed to finalize report", "error");
//     } catch (e) {
//       console.warn("Failed to show notification:", e);
//     }
//   }
// }


// // ──────────────────────────────────────────────────────
// // CORE INIT
// // ──────────────────────────────────────────────────────
// async function init() {
//   PerfTracker.start("INIT_TOTAL");
//   console.log("🚀 Taskpane initializing");

//   // ── WebSocket ───────────────────────────
//   window.wsManager = new EnhancedWebSocketManager(BACKEND_URL);
//   setMicAvailable(false, "Connecting to backend...");
//   window.wsManager.connect();

//   window.wsManager.on("connected", () => {
//     console.log("🔌 WebSocket connected");
//     isBackendConnected = true;

//     setMicAvailable(true);
//     updateStatus("Connected");

//     if (window.isRecording && window.currentRecordingId) {
//       window.wsManager.send(JSON.stringify({
//         type: "start",
//         id: window.currentRecordingId
//       }));
//     }
//   });

//   window.wsManager.on("disconnected", () => {
//     console.log("❌ WebSocket disconnected");
//     isBackendConnected = false;

//     setMicAvailable(false, "Backend disconnected");
//     updateStatus("Disconnected");

//     try {
//       showNotification(
//         "Connection to backend lost. Recording is disabled.",
//         "error"
//       );
//     } catch { }
//   });

//   // ── Transcription handler with SMART DIFF UPDATE ──
//   window.wsManager.on("transcription", async (payload) => {
//     let transcription = "";

//     if (typeof payload === "string") {
//       transcription = payload;
//     } else if (payload && typeof payload === "object") {
//       transcription = payload.transcription || payload.raw_transcription || "";
//     }

//     const text = transcription.trim();
//     if (!text) return;

//     console.log("📥 Transcription:", text.substring(0, 100));

//     try {
//       // Check if we have an active field for surgical update
//       if (window.FieldStateManager && window.FieldStateManager.hasActiveField()) {
//         console.log("→ Active field → surgical update");
//         const success = await window.performSurgicalFieldUpdate(text);

//         if (success) {
//           return; // Done - don't do normal insert
//         }

//         console.warn("⚠ Surgical update failed, falling back");
//       } else {
//         console.log("→ No active field → normal insert");
//       }

//       // No active field OR surgical update failed → normal text insert
//       pendingInsertQueue.push({
//         text: text + " ",
//         receivedAt: Date.now()
//       });

//       const totalChars = pendingInsertQueue.reduce((s, p) => s + p.text.length, 0);
//       if (totalChars >= MIN_CHARS_TO_FLUSH) {
//         clearTimeout(flushTimeout);
//         flushTimeout = null;
//         await flushPendingInserts();
//       } else if (!flushTimeout) {
//         flushTimeout = setTimeout(flushPendingInserts, FLUSH_DELAY_MS);
//       }
//     } catch (err) {
//       console.error("❌ Transcription handler error:", err);
//       // Always fallback to queue
//       pendingInsertQueue.push({ text: text + " ", receivedAt: Date.now() });
//       if (!flushTimeout) {
//         flushTimeout = setTimeout(flushPendingInserts, FLUSH_DELAY_MS);
//       }
//     }
//   });

//   // ── Field Update handler (deprecated - use transcription instead) ──
//   window.wsManager.on("fieldUpdate", (payload) => {
//     console.log("🔄 Received field update:", payload);

//     if (payload && payload.newContent) {
//       // Use surgical diff-based update with visual highlighting
//       applySurgicalFieldUpdate(payload.newContent);
//     }
//   });


//   // Conclusion Generation Response
//   window.wsManager.on("conclusionGeneration", (data) => {
//     console.log("🏥 Received conclusion:", data);
//     if (data.suggestion) {
//       insertConclusionText(data.suggestion);
//       updateStatus("Conclusion generated successfully");
//     } else {
//       console.warn("No conclusion text in response");
//       updateStatus("Failed to generate conclusion");
//     }
//   });

//   window.wsManager.on("conclusionGenerationError", (data) => {
//     console.error("🏥 Conclusion generation error:", data);
//     updateStatus("Error generating conclusion");
//     try {
//       showNotification(data.error || "Failed to generate conclusion", "error");
//     } catch (e) {
//       console.warn("Failed to show error notification:", e);
//     }
//   });


//   // ── Arrow navigation from backend ──
//   window.wsManager.on("arrowPressed", async (data) => {
//     const direction = data?.direction || data;

//     try {
//       if (direction === "RIGHT") {
//         await goToNextField();
//       } else if (direction === "LEFT") {
//         await goToPreviousField();
//       }

//       // ★ IMPORTANT: Field state is now captured inside goToNextField/goToPreviousField
//       // No additional code needed here

//     } catch (error) {
//       console.error("Navigation error:", error);
//       updateStatus("Navigation failed");
//     }
//   });


//   // ── Audio Recorder ──────────────────────
//   window.audioRecorder = new AudioRecorder(window.wsManager);

//   window.audioRecorder.on("started", () => {
//     window.isRecording = true;
//     isFirstTranscription = true;

//     updateMicButton(true);
//     updateStatus("Recording...");

//     window.currentRecordingId = generateRecordingId();

//     if (isBackendConnected) {
//       window.wsManager.send(JSON.stringify({
//         type: "start",
//         id: window.currentRecordingId
//       }));
//     }
//   });

//   window.audioRecorder.on("stopped", () => {
//     window.isRecording = false;
//     updateMicButton(false);
//     updateStatus("Ready");
//     window.currentRecordingId = null;

//     // ★ Clear field state when recording stops
//     if (window.FieldStateManager) {
//       window.FieldStateManager.clear();
//     }
//   });

//   window.audioRecorder.on("error", (err) => {
//     console.error("Audio error:", err);
//     updateStatus("Microphone error");
//   });

//   window.audioRecorder.on("volume", (level) => {
//     const bar = document.getElementById("volumeBar");
//     if (bar) {
//       bar.style.width = `${Math.min(100, level * 2)}%`;
//     }
//   });

//   // Initialize cursor monitoring for "Conclusion" detection
//   setupConclusionMonitoring();

//   // Automatically update date at startup
//   await updateDateAutomatically();

//   PerfTracker.end("INIT_TOTAL");
// }

// // ──────────────────────────────────────────────────────
// // RECORDING TOGGLE (LOGIC PRESERVED)
// // ──────────────────────────────────────────────────────
// async function toggleRecording() {
//   if (!isBackendConnected) {
//     console.warn("Cannot record: backend disconnected");
//     return;
//   }

//   if (window.isRecording) {
//     await window.audioRecorder?.stop();
//     return;
//   }

//   const isReadOnly = await isDocumentReadOnly();
//   if (isReadOnly) {
//     updateStatus("Document is read-only");
//     return;
//   }

//   await window.audioRecorder?.start();
// }

// // ──────────────────────────────────────────────────────
// // INSERT BUFFER FLUSH (UNCHANGED)
// // ──────────────────────────────────────────────────────
// async function flushPendingInserts() {
//   const queue = pendingInsertQueue.slice();
//   pendingInsertQueue = [];
//   flushTimeout = null;

//   const combined = queue.map(p => p.text).join("");
//   if (!combined) return;

//   await insertTextAtCursor(combined);

//   if (isFirstTranscription) {
//     isFirstTranscription = false;
//   }
// }



// // ──────────────────────────────────────────────────────
// // CONCLUSION DETECTION FEATURE
// // ──────────────────────────────────────────────────────

// /**
//  * Set up monitoring for cursor position relative to "Conclusion" marker
//  */
// function setupConclusionMonitoring() {
//   // Callback when cursor is detected after "Conclusion"
//   const handleConclusionDetected = async (result) => {
//     console.group("🔍 Conclusion Detection");
//     console.log("Cursor is positioned after 'Conclusion'");
//     console.log("Marker position:", result.markerPosition);
//     console.log("Text before Conclusion:");
//     console.log(result.textBefore);
//     console.log("Text length:", result.textBefore.length, "characters");
//     console.groupEnd();

//     // Auto-generate conclusion when cursor is positioned after marker
//     await generateConclusion(result.textBefore);
//   };

//   // Set up the monitoring with debouncing
//   cursorMonitor = TextExtractor.setupCursorMonitoring(
//     CONCLUSION_MARKER,
//     handleConclusionDetected,
//     500 // Check 500ms after cursor stops moving
//   );

//   console.log("Conclusion monitoring initialized");
// }

// /**
//  * Manually trigger conclusion detection (can be called from UI button)
//  */
// async function checkForConclusion() {
//   const result = await TextExtractor.getTextBeforeMarker(CONCLUSION_MARKER);

//   if (result.isAfterMarker) {
//     console.group("✅ Manual Conclusion Check - Success");
//     console.log("Text before Conclusion:");
//     console.log(result.textBefore);
//     console.groupEnd();

//     updateStatus("Generating conclusion...");
//     await generateConclusion(result.textBefore);

//     return result.textBefore;
//   } else {
//     console.log("❌ Cursor is not positioned after 'Conclusion' or there is content in between");
//     updateStatus("Cursor not after Conclusion");
//     try {
//       showNotification("Please position cursor right after 'Conclusion' with no text between", "warning");
//     } catch (e) {
//       console.warn("Failed to show notification:", e);
//     }
//     return null;
//   }
// }

// /**
//  * Send description text to backend for conclusion generation
//  */
// async function generateConclusion(descriptionText) {
//   if (!descriptionText || descriptionText.trim().length === 0) {
//     console.warn("No description text to generate conclusion from");
//     updateStatus("No description text found");
//     return;
//   }

//   if (!window.wsManager?.getConnectionStatus()) {
//     console.warn("Cannot generate conclusion: not connected to backend");
//     updateStatus("Not connected to backend");
//     try {
//       showNotification("Cannot generate conclusion: backend is not connected", "warning");
//     } catch (e) {
//       console.warn("Failed to show notification:", e);
//     }
//     return;
//   }

//   console.log("🏥 Requesting conclusion generation for text:", descriptionText.substring(0, 100) + "...");
//   updateStatus("Generating conclusion...");

//   const success = await window.wsManager.sendConclusionGenerationRequest({
//     description_content: descriptionText,
//     username: DOCTOR_USERNAME,
//     department: DOCTOR_DEPARTMENT,
//     timestamp: Date.now()
//   });

//   if (!success) {
//     console.error("Failed to send conclusion generation request");
//     updateStatus("Failed to send request");
//   }
// }

// /**
//  * Insert generated conclusion text at cursor
//  */
// async function insertConclusionText(conclusionText) {
//   if (!conclusionText) return;

//   console.log("📝 Inserting generated conclusion:", conclusionText);

//   try {
//     await Word.run(async (context) => {
//       const range = context.document.getSelection();
//       range.insertText("\n\n" + conclusionText, Word.InsertLocation.end);
//       await context.sync();
//     });
//     console.log("✅ Conclusion inserted successfully");
//   } catch (err) {
//     console.error("❌ Failed to insert conclusion:", err);
//     updateStatus("Error inserting conclusion");
//   }
// }


// // ──────────────────────────────────────────────────────
// // WORD HELPERS
// // ──────────────────────────────────────────────────────
// async function insertTextAtCursor(text) {
//   await Word.run(async (context) => {
//     const range = context.document.getSelection();
//     range.insertText(text, Word.InsertLocation.replace);  // Changed from 'end' to 'replace'
//     range.select(Word.SelectionMode.end);
//     await context.sync();
//   });
// }

// async function isDocumentReadOnly() {
//   try {
//     return await Word.run(async (context) => {
//       context.document.load("isReadOnly");
//       await context.sync();
//       return context.document.isReadOnly;
//     });
//   } catch {
//     return false;
//   }
// }

// function generateRecordingId() {
//   return Date.now().toString(36) + Math.random().toString(36).slice(2);
// }


// // ──────────────────────────────────────────────────────
// // FIELD CONTEXT SENDER
// // ──────────────────────────────────────────────────────
// async function sendCurrentFieldContext() {
//   try {
//     await Word.run(async (context) => {
//       const selection = context.document.getSelection();
//       selection.load("text");

//       await context.sync();

//       const text = selection.text?.trim();

//       // Only send if it's inside [ ... ]
//       // if (!text || !text.startsWith("[") || !text.endsWith("]")) {
//       //   return;
//       // }

//       console.log("📤 Sending field context:", text);

//       if (window.wsManager?.sendFieldContext) {
//         window.wsManager.sendFieldContext({
//           context: text, // remove [ ]
//           username: DOCTOR_USERNAME,
//           department: DOCTOR_DEPARTMENT,
//           timestamp: Date.now()
//         });
//       } else {
//         console.warn("wsManager.sendFieldContext not available");
//       }
//     });
//   } catch (err) {
//     console.error("Failed to send field context:", err);
//   }
// }


// // ──────────────────────────────────────────────────────
// // UI HELPERS (UNCHANGED)
// // ──────────────────────────────────────────────────────
// function updateStatus(message) {
//   const el = document.getElementById("status");
//   if (el) el.textContent = message;
// }

// function setMicAvailable(isAvailable, message = "") {
//   const btn = document.getElementById("micBtn");
//   if (!btn) return;

//   btn.disabled = !isAvailable;
//   btn.classList.toggle("unavailable", !isAvailable);
//   btn.style.filter = isAvailable ? "" : "blur(1px)";

//   if (message) updateStatus(message);
// }

// function updateMicButton(isActive) {
//   const btn = document.getElementById("micBtn");
//   if (!btn) return;

//   btn.classList.toggle("recording", isActive);
// }

// // ──────────────────────────────────────────────────────
// // OFFICE READY
// // ──────────────────────────────────────────────────────
// Office.onReady(async () => {
//   console.log("Doccy Dictation – Taskpane Ready");
//   await init();

//   // Single mic button listener
//   document.getElementById("micBtn")?.addEventListener("click", toggleRecording);

//   // Button to manually trigger conclusion generation
//   document.getElementById("checkConclusionBtn")?.addEventListener("click", checkForConclusion);

//   // Button to finalize report by removing all brackets
//   document.getElementById("finishReportBtn")?.addEventListener("click", finishReport);

//   // Set up selection change listener for real-time detection
//   if (typeof Office !== "undefined" && Office.context && Office.context.document) {
//     let selectionChangeTimeout = null;

//     Office.context.document.addHandlerAsync(
//       Office.EventType.DocumentSelectionChanged,
//       async () => {
//         // Debounce to avoid excessive calls
//         if (selectionChangeTimeout) {
//           clearTimeout(selectionChangeTimeout);
//         }

//         selectionChangeTimeout = setTimeout(async () => {
//           // 🆕 CAPTURE FIELD STATE for surgical updates
//           // await FieldStateManager.captureFieldState();

//           // Existing conclusion monitoring
//           if (cursorMonitor) {
//             cursorMonitor.check();
//           }

//           // Only send field context if NOT currently recording
//           if (!window.isRecording) {
//             await sendCurrentFieldContext();
//           }
//         }, 300);
//       }
//     );
//   }
//   updateStatus("Ready");
// });


// // ──────────────────────────────────────────────────────
// // EXPORTS FOR COMMANDS
// // ──────────────────────────────────────────────────────
// export { toggleRecording, checkForConclusion, finishReport };





/* global Office, Word, document, console */
/* eslint-disable no-restricted-globals */

// ──────────────────────────────────────────────────────
// PERFORMANCE TRACKING UTILITIES (UNCHANGED)
// ──────────────────────────────────────────────────────
const PerfTracker = {
  timers: {},
  start(label) {
    this.timers[label] = performance.now();
    console.log(`⏱️ [START] ${label}`);
  },
  end(label) {
    if (!this.timers[label]) return;
    const duration = performance.now() - this.timers[label];
    console.log(`✅ [END] ${label}: ${duration.toFixed(2)}ms`);
    delete this.timers[label];
    return duration;
  }
};

// ──────────────────────────────────────────────────────
// IMPORTS
// ──────────────────────────────────────────────────────
import { AudioRecorder } from "../lib/AudioRecorder.js";
import { EnhancedWebSocketManager } from "../lib/EnhancedWebSocketManager.js";
import { showNotification } from "../lib/UiNotification.js";
import { goToNextField, goToPreviousField } from "./documentNavigator.js";
import { TextExtractor } from "../lib/TextExtractor.js";
import { MacroManager } from "../lib/MacroManager.js";


// ──────────────────────────────────────────────────────
// GLOBAL STATE
// ──────────────────────────────────────────────────────
window.isRecording = false;
window.audioRecorder = null;
window.wsManager = null;
window.currentRecordingId = null;

let isBackendConnected = false;

// ──────────────────────────────────────────────────────
// TRANSCRIPTION BUFFER (UNCHANGED)
// ──────────────────────────────────────────────────────
const FLUSH_DELAY_MS = 50;
const MIN_CHARS_TO_FLUSH = 1;

let pendingInsertQueue = [];
let flushTimeout = null;
let isFirstTranscription = true;

// Cursor monitoring for "Conclusion" detection
let cursorMonitor = null;

let macroManager = null;           // will be initialized later
let notificationManager = null;    // ← you need to have / create this

// ──────────────────────────────────────────────────────
// CONFIG
// ──────────────────────────────────────────────────────
const BACKEND_URL = "ws://localhost:8765/word_addin";
let DOCTOR_USERNAME = "default_user";
const DOCTOR_DEPARTMENT = "radiology"; // Add your department
const CONCLUSION_MARKER = "Եզրակացություն"; // Configurable marker word
const DATE_MARKER = "Ամսաթիվ"; // Date marker


// ──────────────────────────────────────────────────────
// DATE HELPER FUNCTION
// ──────────────────────────────────────────────────────
function getTodayDateArmenian() {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  return `${day}.${month}.${year}թ.`;
}


// ──────────────────────────────────────────────────────
// AUTO-DATE INSERTION FEATURE
// ──────────────────────────────────────────────────────
async function updateDateAutomatically() {
  try {
    await Word.run(async (context) => {
      // Search for "Ամսաթիվ" in the document
      const searchResults = context.document.body.search(DATE_MARKER, {
        matchCase: true,
        matchWholeWord: false
      });

      searchResults.load("items");
      await context.sync();

      if (searchResults.items.length === 0) {
        console.log("❌ Date marker 'Ամսաթիվ' not found in document");
        return;
      }

      // Get the first occurrence
      const firstMatch = searchResults.items[0];
      firstMatch.load("text");
      await context.sync();

      // Get the entire line/paragraph containing "Ամսաթիվ"
      const paragraph = firstMatch.paragraphs.getFirst();
      paragraph.load("text");
      await context.sync();

      // Get the range after "Ամսաթիվ" to the end of paragraph
      const afterRange = firstMatch.getRange(Word.RangeLocation.after);
      const endOfParagraph = paragraph.getRange(Word.RangeLocation.end);

      // Expand range from after "Ամսաթիվ" to end of paragraph
      const contentAfterMarker = afterRange.expandTo(endOfParagraph);
      contentAfterMarker.load("text");
      await context.sync();

      // Format: "Ամսաթիվ ____  24.01.2025թ. __"
      const dateText = ` ____  ${getTodayDateArmenian()} __`;

      // Replace whatever is after "Ամսաթիվ" with new date
      const insertedRange = contentAfterMarker.insertText(dateText, Word.InsertLocation.replace);
      await context.sync();

      // Highlight the inserted text directly
      insertedRange.font.highlightColor = "Grey"; // highlight
      await context.sync();

      console.log(`✅ Date updated and highlighted: ${dateText}`);

      // Remove highlight after 2.5 seconds
      setTimeout(async () => {
        try {
          await Word.run(async (ctx) => {
            // Search for the date marker again
            const searchAgain = ctx.document.body.search(DATE_MARKER, {
              matchCase: true,
              matchWholeWord: false
            });
            searchAgain.load("items");
            await ctx.sync();

            if (searchAgain.items.length > 0) {
              const match = searchAgain.items[0];
              const para = match.paragraphs.getFirst();
              para.load("text");
              await ctx.sync();

              // Get range after marker and highlight it
              const afterRng = match.getRange(Word.RangeLocation.after);
              const endOfPara = para.getRange(Word.RangeLocation.end);
              const highlightRange = afterRng.expandTo(endOfPara);
              highlightRange.font.highlightColor = null; // Remove highlight
              await ctx.sync();
            }
          });
        } catch (err) {
          console.warn("Could not remove highlight:", err);
        }
      }, 2500);

    });
  } catch (error) {
    console.error("❌ Error updating date:", error);
  }
}


// ──────────────────────────────────────────────────────
// FINISH REPORT - REMOVE ALL BRACKETS
// ──────────────────────────────────────────────────────
async function finishReport() {
  try {
    await Word.run(async (context) => {
      // Search for all bracket fields using the same pattern as navigation
      const results = context.document.body.search("\\[*\\]", {
        matchWildcards: true
      });

      results.load("items");
      await context.sync();

      if (results.items.length === 0) {
        console.log("✅ No brackets found in document");
        updateStatus("Շաբլոնային դաշտեր չեն գտնվել");
        try {
          showNotification("Document already finalized - no brackets found", "info");
        } catch (e) {
          console.warn("Failed to show notification:", e);
        }
        return;
      }

      const totalBrackets = results.items.length;
      console.log(`🗑️ Removing ${totalBrackets} bracket fields...`);

      // Remove brackets from each field, keeping the inner content
      for (const field of results.items) {
        field.load("text");
        await context.sync();

        const fieldText = field.text;
        // Extract content between '[' and ']'
        const innerText = fieldText.slice(1, -1);

        // Replace the entire field (including brackets) with just the inner text
        field.insertText(innerText, Word.InsertLocation.replace);
      }

      await context.sync();

      console.log(`✅ Successfully removed ${totalBrackets} bracket fields`);
      updateStatus("Նկարագրությունը պատրաստ է");

      try {
        showNotification(`Report finalized! Removed ${totalBrackets} bracket fields.`, "success");
      } catch (e) {
        console.warn("Failed to show notification:", e);
      }
    });
  } catch (error) {
    console.error("❌ Error removing brackets:", error);
    updateStatus("Նկարագրությունը պատրաստելը ձախողվեց");
    try {
      showNotification("Failed to finalize report", "error");
    } catch (e) {
      console.warn("Failed to show notification:", e);
    }
  }
}


// ──────────────────────────────────────────────────────
// CORE INIT
// ──────────────────────────────────────────────────────
async function init() {
  PerfTracker.start("INIT_TOTAL");
  console.log("🚀 Taskpane initializing");



  notificationManager = {
    show(message, type = 'info') {
      // You can later replace this with nice toast / modal
      console.log(`[${type.toUpperCase()}] ${message}`);
      const statusEl = document.getElementById("status");
      if (statusEl) {
        const old = statusEl.textContent;
        statusEl.textContent = message;
        statusEl.style.color = type === 'success' ? '#059669' :
          type === 'error' ? '#dc2626' :
            type === 'warning' ? '#d97706' : '#374151';
        setTimeout(() => { statusEl.textContent = old; statusEl.style.color = ''; }, 3200);
      }
    }
  };

  // ────────────────────────────────
  //  Initialize MacroManager
  // ────────────────────────────────
  macroManager = new MacroManager(
    {
      // fake configManager — replace with real one later
      getDoctorUsername: () => DOCTOR_USERNAME || "default_user"
    },
    notificationManager
  );

  await macroManager.init(); // ← add this line


  // ── WebSocket ───────────────────────────
  window.wsManager = new EnhancedWebSocketManager(BACKEND_URL);
  setMicAvailable(false, "Connecting to backend...");
  window.wsManager.connect();

  window.wsManager.on("connected", () => {
    console.log("🔌 WebSocket connected");
    isBackendConnected = true;

    setMicAvailable(true);
    updateStatus("Միացված է");

    if (window.isRecording && window.currentRecordingId) {
      window.wsManager.send(JSON.stringify({
        type: "start",
        id: window.currentRecordingId
      }));
    }
  });

  window.wsManager.on("disconnected", () => {
    console.log("❌ WebSocket disconnected");
    isBackendConnected = false;

    setMicAvailable(false, "Backend disconnected");
    updateStatus("Անջատված է");

    try {
      showNotification(
        "Connection to backend lost. Recording is disabled.",
        "error"
      );
    } catch { }
  });

  window.wsManager.on("transcription", async (payload) => {
    let transcription = "";
    if (typeof payload === "string") {
      transcription = payload;
    } else if (payload && typeof payload === "object") {
      transcription = payload.transcription || payload.raw_transcription || "";
    }

    const text = transcription.trim();
    if (!text) return;

    // ────────────────  VERY IMPORTANT PART  ────────────────
    let finalText = text + " ";   // keep your space

    if (macroManager) {
      try {
        finalText = macroManager.processTranscription(text) + " ";
        if (finalText !== text + " ") {
          console.log(`Macro expansion occurred: "${text}" → "${finalText.trim()}"`);
        }
      } catch (err) {
        console.error("Macro processing failed:", err);
        // fallback → use original text
        finalText = text + " ";
      }
    }
    // ───────────────────────────────────────────────────────

    pendingInsertQueue.push({
      text: finalText,
      receivedAt: Date.now()
    });

    const totalChars = pendingInsertQueue.reduce((s, p) => s + p.text.length, 0);

    if (totalChars >= MIN_CHARS_TO_FLUSH) {
      clearTimeout(flushTimeout);
      flushTimeout = null;
      await flushPendingInserts();
    } else if (!flushTimeout) {
      flushTimeout = setTimeout(flushPendingInserts, FLUSH_DELAY_MS);
    }
  });


  // Conclusion Generation Response
  window.wsManager.on("conclusionGeneration", (data) => {
    console.log("🏥 Received conclusion:", data);
    if (data.suggestion) {
      insertConclusionText(data.suggestion);
      updateStatus("Եզրակացությունը հաջողությամբ գեներացվել է");
    } else {
      console.warn("No conclusion text in response");
      updateStatus("Failed to generate conclusion");
    }
  });

  window.wsManager.on("conclusionGenerationError", (data) => {
    console.error("🏥 Conclusion generation error:", data);
    updateStatus("Եզրակացությունը գեներացնելը ձախողվեց");
    try {
      showNotification(data.error || "Failed to generate conclusion", "error");
    } catch (e) {
      console.warn("Failed to show error notification:", e);
    }
  });


  // ── Arrow navigation from backend ──
  window.wsManager.on("arrowPressed", async (data) => {
    const direction = data?.direction || data;

    try {
      if (direction === "RIGHT") {
        await goToNextField();
      } else if (direction === "LEFT") {
        await goToPreviousField();
      }
    } catch (error) {
      console.error("Navigation error:", error);
      updateStatus("Նավարկումը ձախողվեց");
    }
  });

  // ── Audio Recorder ──────────────────────
  window.audioRecorder = new AudioRecorder(window.wsManager);

  window.audioRecorder.on("started", () => {
    window.isRecording = true;
    isFirstTranscription = true;

    updateMicButton(true);
    updateStatus("Ձայնագրում է...");

    window.currentRecordingId = generateRecordingId();

    if (isBackendConnected) {
      window.wsManager.send(JSON.stringify({
        type: "start",
        id: window.currentRecordingId
      }));
    }
  });

  window.audioRecorder.on("stopped", () => {
    window.isRecording = false;
    updateMicButton(false);
    updateStatus("Պատրաստ է");
    window.currentRecordingId = null;
  });

  window.audioRecorder.on("error", (err) => {
    console.error("Audio error:", err);
    updateStatus("Ձայնագրիչի սխալ");
  });

  window.audioRecorder.on("volume", (level) => {
    const bar = document.getElementById("volumeBar");
    if (bar) {
      bar.style.width = `${Math.min(100, level * 2)}%`;
    }
  });

  // Initialize cursor monitoring for "Conclusion" detection
  setupConclusionMonitoring();

  // Automatically update date at startup
  await updateDateAutomatically();

  PerfTracker.end("INIT_TOTAL");
}

// ──────────────────────────────────────────────────────
// RECORDING TOGGLE (LOGIC PRESERVED)
// ──────────────────────────────────────────────────────
async function toggleRecording() {
  if (!isBackendConnected) {
    console.warn("Cannot record: backend disconnected");
    return;
  }

  if (window.isRecording) {
    await window.audioRecorder?.stop();
    return;
  }

  const isReadOnly = await isDocumentReadOnly();
  if (isReadOnly) {
    updateStatus("Դոկումենտը միայն կարդալու ռեժիմում է");
    return;
  }

  await window.audioRecorder?.start();
}

// ──────────────────────────────────────────────────────
// INSERT BUFFER FLUSH (UNCHANGED)
// ──────────────────────────────────────────────────────
async function flushPendingInserts() {
  const queue = pendingInsertQueue.slice();
  pendingInsertQueue = [];
  flushTimeout = null;

  const combined = queue.map(p => p.text).join("");
  if (!combined) return;

  await insertTextAtCursor(combined);

  if (isFirstTranscription) {
    isFirstTranscription = false;
  }
}



// ──────────────────────────────────────────────────────
// CONCLUSION DETECTION FEATURE
// ──────────────────────────────────────────────────────

/**
 * Set up monitoring for cursor position relative to "Conclusion" marker
 */
function setupConclusionMonitoring() {
  // Callback when cursor is detected after "Conclusion"
  const handleConclusionDetected = async (result) => {
    console.group("🔍 Conclusion Detection");
    console.log("Cursor is positioned after 'Conclusion'");
    console.log("Marker position:", result.markerPosition);
    console.log("Text before Conclusion:");
    console.log(result.textBefore);
    console.log("Text length:", result.textBefore.length, "characters");
    console.groupEnd();

    // Auto-generate conclusion when cursor is positioned after marker
    await generateConclusion(result.textBefore);
  };

  // Set up the monitoring with debouncing
  cursorMonitor = TextExtractor.setupCursorMonitoring(
    CONCLUSION_MARKER,
    handleConclusionDetected,
    500 // Check 500ms after cursor stops moving
  );

  console.log("Conclusion monitoring initialized");
}

/**
 * Manually trigger conclusion detection (can be called from UI button)
 */
async function checkForConclusion() {
  const result = await TextExtractor.getTextBeforeMarker(CONCLUSION_MARKER);

  if (result.isAfterMarker) {
    console.group("✅ Manual Conclusion Check - Success");
    console.log("Text before Conclusion:");
    console.log(result.textBefore);
    console.groupEnd();

    updateStatus("Եզրակացությունը գեներացվում է...");
    await generateConclusion(result.textBefore);

    return result.textBefore;
  } else {
    console.log("❌ Cursor is not positioned after 'Conclusion' or there is content in between");
    updateStatus("Տեղադրեք կուրսորը 'Եզրակացություն'-ից հետո");
    try {
      showNotification("Please position cursor right after 'Conclusion' with no text between", "warning");
    } catch (e) {
      console.warn("Failed to show notification:", e);
    }
    return null;
  }
}

/**
 * Send description text to backend for conclusion generation
 */
async function generateConclusion(descriptionText) {
  if (!descriptionText || descriptionText.trim().length === 0) {
    console.warn("No description text to generate conclusion from");
    updateStatus("Նկարագրություն չի գտնվել");
    return;
  }

  if (!window.wsManager?.getConnectionStatus()) {
    console.warn("Cannot generate conclusion: not connected to backend");
    updateStatus("backend-ը միացված չէ");
    try {
      showNotification("Cannot generate conclusion: backend is not connected", "warning");
    } catch (e) {
      console.warn("Failed to show notification:", e);
    }
    return;
  }

  console.log("🏥 Requesting conclusion generation for text:", descriptionText.substring(0, 100) + "...");
  updateStatus("Եզրակացությունը գեներացվում է...");

  const success = await window.wsManager.sendConclusionGenerationRequest({
    description_content: descriptionText,
    username: DOCTOR_USERNAME,
    department: DOCTOR_DEPARTMENT,
    timestamp: Date.now()
  });

  if (!success) {
    console.error("Failed to send conclusion generation request");
    updateStatus("Չհաջողվեց գեներացնել եզրակացությունը");
  }
}

/**
 * Insert generated conclusion text at cursor with formatting matching description text
 */
async function insertConclusionText(conclusionText) {
  if (!conclusionText) return;

  console.log("📝 Inserting generated conclusion:", conclusionText);

  try {
    await Word.run(async (context) => {
      // Search for the "Եզրակացություն" marker
      const conclusionMarkerSearch = context.document.body.search(CONCLUSION_MARKER, {
        matchCase: true,
        matchWholeWord: false
      });

      conclusionMarkerSearch.load("items");
      await context.sync();

      if (conclusionMarkerSearch.items.length === 0) {
        console.warn("Conclusion marker not found, using default insertion");
        const range = context.document.getSelection();
        range.insertText("\n\n" + conclusionText, Word.InsertLocation.end);
        await context.sync();
        return;
      }

      // Get the paragraph containing the conclusion marker
      const markerRange = conclusionMarkerSearch.items[0];
      const markerParagraph = markerRange.paragraphs.getFirst();

      // Get the paragraph before the conclusion marker (description text)
      const previousParagraph = markerParagraph.getPreviousOrNullObject();
      previousParagraph.load(["font", "style"]);
      await context.sync();

      // Get current cursor position
      const range = context.document.getSelection();

      // Insert the conclusion text
      const insertedRange = range.insertText("\n\n" + conclusionText, Word.InsertLocation.end);

      // Copy formatting from the description paragraph if it exists
      if (!previousParagraph.isNullObject) {
        insertedRange.font.name = previousParagraph.font.name;
        insertedRange.font.size = previousParagraph.font.size;
        insertedRange.font.color = previousParagraph.font.color;
        insertedRange.font.bold = previousParagraph.font.bold;
        insertedRange.font.italic = previousParagraph.font.italic;
        insertedRange.style = previousParagraph.style;

        console.log("✅ Applied formatting from description text");
      } else {
        console.log("⚠️ No previous paragraph found, using default formatting");
      }

      await context.sync();
      console.log("✅ Conclusion inserted successfully with matching style");
    });
  } catch (err) {
    console.error("❌ Failed to insert conclusion:", err);
    updateStatus("Եզրակացությունը ներդրելը ձախողվեց");
  }
}


// ──────────────────────────────────────────────────────
// WORD HELPERS
// ──────────────────────────────────────────────────────
async function insertTextAtCursor(text) {
  await Word.run(async (context) => {
    const range = context.document.getSelection();
    range.insertText(text, Word.InsertLocation.replace);  // Changed from 'end' to 'replace'
    range.select(Word.SelectionMode.end);
    await context.sync();
  });
}

async function isDocumentReadOnly() {
  try {
    return await Word.run(async (context) => {
      context.document.load("isReadOnly");
      await context.sync();
      return context.document.isReadOnly;
    });
  } catch {
    return false;
  }
}

function generateRecordingId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}


// ──────────────────────────────────────────────────────
// FIELD CONTEXT SENDER
// ──────────────────────────────────────────────────────
async function sendCurrentFieldContext() {
  try {
    await Word.run(async (context) => {
      const selection = context.document.getSelection();
      selection.load("text");

      await context.sync();

      const text = selection.text?.trim();

      // Only send if it's inside [ ... ]
      // if (!text || !text.startsWith("[") || !text.endsWith("]")) {
      //   return;
      // }

      console.log("📤 Sending field context:", text);

      if (window.wsManager?.sendFieldContext) {
        window.wsManager.sendFieldContext({
          context: text, // remove [ ]
          username: DOCTOR_USERNAME,
          department: DOCTOR_DEPARTMENT,
          timestamp: Date.now()
        });
      } else {
        console.warn("wsManager.sendFieldContext not available");
      }
    });
  } catch (err) {
    console.error("Failed to send field context:", err);
  }
}


// ──────────────────────────────────────────────────────
// UI HELPERS (UNCHANGED)
// ──────────────────────────────────────────────────────
function updateStatus(message) {
  const el = document.getElementById("status");
  if (el) el.textContent = message;
}

function setMicAvailable(isAvailable, message = "") {
  const btn = document.getElementById("micBtn");
  if (!btn) return;

  btn.disabled = !isAvailable;
  btn.classList.toggle("unavailable", !isAvailable);
  btn.style.filter = isAvailable ? "" : "blur(1px)";

  if (message) updateStatus(message);
}

function updateMicButton(isActive) {
  const btn = document.getElementById("micBtn");
  if (!btn) return;

  btn.classList.toggle("recording", isActive);
}

// ──────────────────────────────────────────────────────
// OFFICE READY
// ──────────────────────────────────────────────────────
Office.onReady(async () => {
  console.log("Doccy Dictation – Taskpane Ready");

  // Set up username login modal
  const usernameInput = document.getElementById("usernameInput");
  const setUsernameBtn = document.getElementById("setUsernameBtn");
  const usernameModalOverlay = document.getElementById("usernameModalOverlay");
  const mainApp = document.getElementById("mainApp");

  // Check if username is already stored
  const savedUsername = localStorage.getItem("doccy_username");

  const startMainApp = () => {
    // Initialize the app
    init().then(() => {
      // Set up event listeners for main app buttons
      document.getElementById("micBtn")?.addEventListener("click", toggleRecording);
      document.getElementById("finishReportBtn")?.addEventListener("click", finishReport);

      document.getElementById("macrosBtn")?.addEventListener("click", () => {
        if (macroManager) {
          macroManager.showMacroManager();
        } else {
          console.error("MacroManager not initialized");
          notificationManager?.show("Հրահանգների համակարգը բեռնված չէ", "error");
        }
      });

      // Set up selection change listener for real-time detection
      if (typeof Office !== "undefined" && Office.context && Office.context.document) {
        Office.context.document.addHandlerAsync(
          Office.EventType.DocumentSelectionChanged,
          async () => {
            if (cursorMonitor) {
              cursorMonitor.check();
            }
          }
        );
      }

      updateStatus("Պատրաստ է");
    });
  };

  if (savedUsername) {
    // Username already exists, skip modal and go straight to main app
    console.log(`✅ Username loaded from storage: ${savedUsername}`);
    DOCTOR_USERNAME = savedUsername;

    // Hide modal and show main app immediately
    usernameModalOverlay.classList.add("hidden");
    usernameModalOverlay.style.display = "none";
    mainApp.style.display = "flex";

    startMainApp();
  } else {
    // No saved username, show modal
    if (setUsernameBtn && usernameInput) {
      const handleUsernameSubmit = () => {
        const username = usernameInput.value.trim();
        if (username) {
          DOCTOR_USERNAME = username;
          
          // Save username to localStorage
          localStorage.setItem("doccy_username", username);
          console.log(`✅ Username set and saved to storage: ${username}`);

          // Hide modal with animation
          usernameModalOverlay.classList.add("hidden");

          // Show main app after animation
          setTimeout(() => {
            usernameModalOverlay.style.display = "none";
            mainApp.style.display = "flex";
            
            startMainApp();
          }, 300);
        } else {
          notificationManager?.show("Անունը չի կարող դատարկ լինել", "error");
        }
      };

      setUsernameBtn.addEventListener("click", handleUsernameSubmit);

      // Allow Enter key to submit
      usernameInput.addEventListener("keypress", (e) => {
        if (e.key === "Enter") {
          handleUsernameSubmit();
        }
      });

      // Focus on input when page loads
      usernameInput.focus();
    }
  }
});

// ──────────────────────────────────────────────────────
// EXPORTS FOR COMMANDS
// ──────────────────────────────────────────────────────
export { toggleRecording, checkForConclusion, finishReport };